import React, { useEffect, useMemo, useRef, useState } from "react";
import Container from "../../components/Layout/Container";
import ContentBlock from "../../components/Layout/ContentBlock";
import FilterMenu from "../../components/Layout/FilterMenu";
import {
  antdMessageError,
  antdMessageSuccess,
  exportDocument,
  formatDatePlus,
  getDateFormat,
  prettyDateFormat,
} from "../../helpers/Utils";
import TableFilterBox from "../../components/common/TableFilterBox";
import RangePickerComp from "../../components/common/RangePickerComp";
import { useDispatch, useSelector } from "react-redux";
import {
  close_manifest,
  getManifests,
  manifestDownload,
  manifestDownloadStackedLabels,
  manifestDownloadStackedLabelsA5,
  manifestLabelsDownload,
} from "../../redux/Actions/manifestAction";
import ContentValidation from "../../components/common/ContentValidation";
import useChecked from "../../hooks/useChecked";
import {
  CheckBoxInput,
  LongButton,
  SimpleDownloadButton,
} from "../../components/common/Buttons";
import PaginationComp from "../../components/Dashboard/items/Pagination";
import { Dropdown, Tooltip } from "antd";
import DeliverySvg from "../../../assets/images/delivery.svg";
import { GoPrimitiveDot } from "react-icons/go";
import moment from "moment";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { SelectInput, TextInput } from "../../components/globals";
import SwitchComp from "../../components/common/SwitchComp";
import { MdErrorOutline } from "react-icons/md";
import { shipment_types_options } from "../../helpers/GlobalOptions";

import TableUi from "../../components/Layout/TableUI";
import AntdConfirm from "../../helpers/AntdConfirm";
import { getOrder } from "../../redux/Actions/orderAction";
import { OrderDetailsModal } from "../../components/globals/modals";
import DpdManifestModal from "./DPDManifestModal";
import {
  setOrderShopsOptions,
  setPickupAddressesOptions,
} from "../../redux/Actions/options_action";
import ShipmentTypeRender from "./ShipmentTypeRender";
import { removeDuplicates } from "../../helpers/array";
import { isNumber } from "../../helpers/number";
import NewInputSwitchComponent from "../../components/common/NewInputSwitchComponent";
import { handleKeyDown2 } from "../../helpers/FunctionsGlobal";
import DefaultManifestShipmentType from "./manifests/components/DefaultManifestShipmentType";
import { colors } from "../../utils/colors";
import DropdownButton from "../products/components/SuppliersManagement/Components/DropdownButton";
import axios from "axios";

const initialFilters = {
  created_at: ["", ""],
  closed_at_not_null: false,
  called_at_not_null: false,
  shipments_orders_id_order_cont: null,
  pickup_address_code_cont_any: null,
  carrier_in: [],
  shipments_orders_order_shop_id_in: [],
  page: 1,
};

const defaultFilters = [
  {
    label: "Date",
    value: "created_at",
    type: "date",
  },
  {
    type: "switch",
    label: "Passed",
    value: "closed_at_not_null",
  },
  {
    type: "switch",
    label: "Pickup",
    value: "called_at_not_null",
  },
  // {
  //   label: "Manifesto sukūrimo d.",
  //   value: "manifest_created_at",
  //   type: "date",
  // },
  {
    label: "Order no.",
    value: "shipments_orders_id_order_cont",
  },
  {
    label: "Order store",
    value: "shipments_orders_order_shop_id_in",
  },
  {
    label: "Supplier",
    value: "pickup_address_code_cont_any",
  },
  {
    label: "Carrier",
    value: "carrier_in",
  },
  {
    label: "Page",
    value: "page",
  },
];

function DeliveriesManifestPage({ match }) {
  const dispatch = useDispatch();

  const modalRef = useRef();
  const { totals, manifest, loading_manifest } = useSelector(
    (state) => state.manifest
  );
  const { pickup_addresses, order_shops } = useSelector(
    (state) => state.options
  );

  const [pageCount, setPageCount] = useState(50);
  const [filters, setFilters] = useState(initialFilters);
  const [paramsFilter, setParamsFilter] = useState("");
  const [initialFetched, setInitialFetched] = useState(false);

  const [modalPreview, setModalPreview] = useState({
    record: "",
    recordId: "",
  });

  const { onChangeChecked, checkedIncluded, setChecked, checkedAll, checked } =
    useChecked([]);

  useEffect(() => {
    clearFilter(1);
    dispatch(setPickupAddressesOptions());
    dispatch(setOrderShopsOptions());
  }, []);

  useEffect(() => {
    if (initialFetched) {
      dispatch(
        getManifests("all", filters?.page || 1, pageCount, paramsFilter)
      );
    }
  }, [filters?.page, pageCount, paramsFilter]);

  const carrierOptions = useMemo(() => {
    const options = [...shipment_types_options];

    // dpd at the store
    const at_the_store_index = options.findIndex(
      (t) => t.value == "at_the_store"
    );
    options[at_the_store_index].label = `[DPD] Withdrawal in the office`;
    const at_the_store = options.splice(at_the_store_index, 1)[0];
    options.splice(1, 0, at_the_store);

    // lp at the store
    options.splice(4, 0, {
      label: "[LP] Withdrawal in the office",
      value: "at_the_store_lp",
    });
    // venipak at the store
    options.splice(6, 0, {
      label: "[Venipak] Withdrawal in the office",
      value: "at_the_store_venipak",
    });
    options.splice(1, 0, {
      label: "Also/Bigbox",
      value: "Also/Bigbox",
    });
    options.splice(4, 0, {
      label: "Also/Bigbox Omniva",
      value: "Also/Bigbox Omniva",
    });
    // options.push({
    //   label: "Ziticity",
    //   value: "ziticity",
    // });
    return options.map((option) => ({
      ...option,
      label: <ShipmentTypeRender {...option} />,
    }));
  }, []);

  const clearFilter = (type = 0) => {
    let filters = {};
    defaultFilters.forEach((d) => {
      filters[Object.entries(d)[1][1]] = d.type == "date" ? ["", ""] : "";
    });
    if (type == 1) {
      const searchParams = new URLSearchParams(window.location.search);
      for (const [key, value] of searchParams.entries()) {
        const reKey = key
          .replace(/q\[|\]\[]/g, "")
          .replace("]", "")
          .replace("[", "");
        if (reKey == "created_at") {
          filters.created_at = reKey.includes("gteq")
            ? [value, filters.created_at[1]]
            : [filters.created_at[0], value];
        } else if (reKey.includes("_in")) {
          if (!filters[reKey]) {
            filters[reKey] = [];
          }
          if (isNumber(value)) {
            filters[reKey].push(+value);
          } else {
            filters[reKey].push(value);
          }
        } else {
          filters[reKey] = decodeURI(value);
        }
      }
    }

    filters.page = 1;
    setFilters(filters);
    onFilter(filters);
  };

  const onFilter = (filterObj = filters) => {
    let filtStr = Object.entries(filterObj)
      .filter(([key, value]) => {
        // Filter out empty or undefined values
        if (!value) return false;

        if (key === "created_at") {
          const [startDate, endDate] = value;
          const filters = [];

          if (startDate) filters.push(`q[${key}_gteq]=${startDate}`);
          if (endDate)
            filters.push(`q[${key}_lteq]=${formatDatePlus(endDate)}`);

          return filters.length > 0;
        }

        if (key.includes("_in") && Array.isArray(value)) {
          return value.length > 0;
        }

        if (typeof value === "string") {
          value = value.trim();
          return value.length > 0;
        }
        if (typeof value == "boolean" && value) return true;

        return typeof value === "string";
      })
      .map(([key, value]) => {
        if (key === "created_at") {
          const [startDate, endDate] = value;
          const filters = [];

          if (startDate) filters.push(`q[${key}_gteq]=${startDate}`);
          if (endDate)
            filters.push(`q[${key}_lteq]=${formatDatePlus(endDate)}`);

          return filters.join("&");
        }

        if (key.includes("_in") && Array.isArray(value)) {
          return value.map((s) => `q[${key}][]=${s}`).join("&");
        }

        return `q[${key}]=${value}`;
      })
      .join("&");
    if (filtStr !== "") {
      filtStr = "&" + filtStr;
    }

    if (paramsFilter == filtStr || !initialFetched) {
      dispatch(getManifests("all", filterObj?.page || 1, pageCount, filtStr));
    } else {
      setParamsFilter(filtStr || "");
    }

    setInitialFetched(true);

    const newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?${filtStr}`;
    window.history.pushState({ path: newUrl }, "", newUrl);
  };

  const bulkAction = async (ids, bulk_action) => {
    try {
      const response = await axios.post("/api/v1/manifests/bulk_action", {
        ids,
        bulk_action,
      });
      antdMessageSuccess("Bulk action completed successfully");
      return response.data;
    } catch (error) {
      antdMessageError(`Bulk action failed: ${error.message}`);
      throw error;
    }
  };

  const renderCustomButton = () => {
    const handleBulkAction = async (action) => {
      if (checked.length === 0) {
        return antdMessageError("No items selected");
      }

      AntdConfirm({
        title: `Are you sure you want to ${action.replace("_", " ")}?`,
        onOk: async () => {
          try {
            await bulkAction(checked, action);
            await dispatch(getManifests("all", filters?.page || 1, pageCount));
          } catch (error) {
            console.error(error);
          }
        },
      });
    };

    return (
      <>
        <div
          className="float-left ml-2"
          style={{ width: 100, position: "relative" }}
        >
          <DropdownButton
            buttonText="Bulk action"
            buttonId="bulk-action"
            style={{
              width: 104,
              height: 29,
              lineHeight: "19px",
              backgroundColor: "#007bff",
              fontWeight: "600",
              padding: "5px 10px",
              fontSize: 12,
              boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
            }}
            child={
              <div>
                <div
                  onClick={() => handleBulkAction("call")}
                  className="bulk-action-dropbox"
                  style={{
                    cursor: "pointer",
                  }}
                >
                  <p
                    style={{
                      fontSize: 12,
                      color: "#2B2A29",
                      paddingLeft: 8,
                      paddingRight: 8,
                      paddingTop: 8,
                      paddingBottom: 8,
                      marginBottom: 0,
                    }}
                  >
                    Call courier
                  </p>
                </div>
                <div
                  onClick={() => handleBulkAction("close")}
                  className="bulk-action-dropbox"
                  style={{
                    cursor: "pointer",
                  }}
                >
                  <p
                    style={{
                      fontSize: 12,
                      paddingTop: 8,
                      paddingBottom: 8,
                      paddingLeft: 8,
                      paddingRight: 8,
                      marginBottom: 0,
                      color: "#2B2A29",
                    }}
                  >
                    Close manifest
                  </p>
                </div>
                <div
                  onClick={() => handleBulkAction("close_call")}
                  className="bulk-action-dropbox"
                  style={{
                    cursor: "pointer",
                  }}
                >
                  <p
                    style={{
                      fontSize: 12,
                      paddingTop: 8,
                      paddingBottom: 8,
                      paddingLeft: 8,
                      paddingRight: 8,
                      marginBottom: 0,
                      color: "#2B2A29",
                    }}
                  >
                    Close manifest and call courier
                  </p>
                </div>
              </div>
            }
          />
        </div>
        <Dropdown
          menu={{
            items: [
              {
                key: "1",
                label: (
                  <div
                    onClick={() => {
                      if (checked.length == 0)
                        return antdMessageError("Not selected");
                      AntdConfirm({
                        onOk: () => {
                          exportDocument(
                            "/api/v1/manifests/export_shipments_in_excel",
                            "manifest.xlsx",
                            "post",
                            {
                              checked,
                            }
                          );
                          console.log("OK");
                        },
                      });
                    }}
                  >
                    Export selected
                  </div>
                ),
              },
              {
                key: "2",
                label: (
                  <div
                    onClick={() => {
                      AntdConfirm({
                        onOk: () => {
                          exportDocument(
                            `/api/v1/manifests/export_shipments_in_excel?${paramsFilter}`,
                            "manifest.xlsx",
                            "post"
                          );
                          console.log("OK");
                        },
                      });
                    }}
                  >
                    Export all
                  </div>
                ),
              },
            ],
          }}
          placement="bottomRight"
        >
          <button
            className="btn btn-sm btn-dark float-right mr-3 dropdown-toggle"
            type="button"
          >
            Export
          </button>
        </Dropdown>
        <DefaultManifestShipmentType />
      </>
    );
  };

  return (
    <Container
      location={{
        locationName: "Manifests",
        locationUrl: match.url,
      }}
    >
      <ContentBlock>
        <FilterMenu
          totals={totals}
          length={manifest.length}
          onChangeCountPage={setPageCount}
          countPage={pageCount}
          text2="Manifests"
        />
      </ContentBlock>

      <ContentBlock containerClass="py-1">
        <TableFilterBox
          filter={true}
          onFilter={() => onFilter()}
          clearFilter={() => clearFilter()}
          button1={renderCustomButton()}
        >
          {defaultFilters.map((filter) => (
            <div className="px-1" key={filter.value}>
              {filter?.label == "Carrier" ? (
                <NewInputSwitchComponent
                  type="multiple"
                  labelClassName="text-sm-label"
                  label={filter.label}
                  name={filter.value}
                  options={carrierOptions}
                  value={filters[filter.value]}
                  onChange={({ target }) => {
                    setFilters((prev) => ({
                      ...prev,
                      [filter.value]: target.value,
                    }));
                  }}
                />
              ) : filter?.type == "switch" ? (
                <span>
                  <SwitchComp
                    labelClassName="text-sm-label"
                    placeholder={filter.label}
                    checked={filters[filter.value]}
                    onChange={() =>
                      setFilters((prev) => ({
                        ...prev,
                        [filter.value]: !filters[filter.value],
                      }))
                    }
                  />
                </span>
              ) : filter?.type == "date" ? (
                <RangePickerComp
                  label={filter.label}
                  style={{ width: 250 }}
                  value={
                    filters[filter.value]
                      ? [
                        getDateFormat(filters[filter.value][0]),
                        getDateFormat(filters[filter.value][1]),
                      ]
                      : []
                  }
                  onChange={(_, args) => {
                    setFilters((prev) => ({
                      ...prev,
                      [filter.value]: args,
                    }));
                  }}
                />
              ) : filter.value == "page" ? null : [
                "Supplier",
                "Order store",
              ].includes(filter.label) ? (
                <SelectInput
                  mode={filter.label == "Supplier" ? "simple" : "multiple"}
                  label={filter.label}
                  style={{ width: 165 }}
                  options={
                    filter.label == "Supplier"
                      ? [
                        {
                          value: "",
                          label: "All",
                        },
                        ...pickup_addresses?.map((option) => ({
                          value: option.code,
                          label: option.label,
                        })),
                      ]
                      : order_shops
                  }
                  value={filters[filter.value] || undefined}
                  onChange={(value) => {
                    setFilters((prev) => ({
                      ...prev,
                      [filter.value]: value,
                    }));
                  }}
                />
              ) : (
                <TextInput
                  text={filter.label}
                  name={filter.value}
                  style={{ width: 165 }}
                  value={filters[filter.value] || ""}
                  onKeyDown={handleKeyDown2(onFilter)}
                  onChange={(val) => {
                    const value = val.target.value;
                    setFilters((prev) => ({
                      ...prev,
                      [filter.value]: value,
                    }));
                  }}
                />
              )}
            </div>
          ))}
        </TableFilterBox>
        <div>
          <ContentValidation loader={loading_manifest} array={manifest}>
            <div className="table-responsive">
              <TableUi
                ths={[
                  <CheckBoxInput
                    checked={checkedAll(manifest.map(({ id }) => id))}
                    onChange={() => {
                      if (checkedAll(manifest.map(({ id }) => id))) {
                        setChecked([]);
                      } else {
                        setChecked(manifest.map(({ id }) => id));
                      }
                    }}
                  />,
                  "Carrier",
                  "Store",
                  "",
                  "Error",
                  "Passed",
                  "Pickup",
                  "ALSO",
                  "Labels",
                  "Created at",
                  "Supplier",
                  "Order no.",
                  "Order info",
                  "Shipments",
                  "Packets",
                  "Weight",
                  "Manifest",
                  "Tickets A4",
                  "Tickets A5",
                  "Tickets A6",
                ]}
                total={manifest?.length || 0}
              >
                {manifest.map((item) => (
                  <TableColumn
                    key={item.id}
                    item={item}
                    checked={checkedIncluded(item.id)}
                    checkedChange={() => onChangeChecked(item.id)}
                    onModalAction={(type, value) => {
                      setModalPreview({
                        record: type,
                        recordId: value.id,
                      });
                      if (type == "order") {
                        dispatch(getOrder(value.custom));
                        modalRef.current.openModal("OrderShowModal");
                      }
                    }}
                  />
                ))}
              </TableUi>
              <PaginationComp
                page={filters?.page || 1}
                setPagination={(value) => {
                  setFilters((prev) => ({
                    ...prev,
                    page: value + "",
                  }));
                }}
                totals={totals}
                pageCount={pageCount}
              />
            </div>
          </ContentValidation>
        </div>
      </ContentBlock>
      {modalPreview?.record == "call_courrier" && (
        <DpdManifestModal
          actionId={modalPreview?.recordId}
          onClose={() => setModalPreview({ recordId: "", record: "" })}
        />
      )}
      <div id="modal-roots" />
      <OrderDetailsModal
        ref={modalRef}
        requiredOrderId={modalPreview?.recordId}
      />
    </Container>
  );
}

export default DeliveriesManifestPage;

function TableColumn({ onModalAction, checked, checkedChange, ...props }) {
  const { item } = props;
  const dispatch = useDispatch();
  const countPackets = (array) => {
    let total = array.reduce((acc, cur) => acc + +cur.packets, 0);
    return total;
  };

  const countWeight = (array) => {
    let total = array.reduce((acc, cur) => acc + +cur.weight, 0);
    return total;
  };
  const ordersId = (array) => {
    return array.map((item, i) => (
      <span key={`orderkey_${item.id}`}>
        <a
          className="text-primary"
          onClick={() => {
            onModalAction("order", {
              id: item.order.id_order,
              custom: item.order.id,
            });
          }}
        >
          {item.order.id_order}
        </a>
        {array.length - 1 == i ? "" : ", "}
        {(i + 1) % 2 === 0 && <br />}
      </span>
    ));
  };

  // Konsoliduotas atsiemimas
  const combined_shipment = item.to_office && !!item.store;

  return (
    <TableUi.tr className="align-middle tableColumn">
      <TableUi.td className={"p-left position-relative"}>
        {combined_shipment && (
          <div
            className="position-absolute"
            style={{
              background: `linear-gradient(90deg, ${colors["purple"]} 0%, rgba(134, 120, 171, 0) 100%)`,
              width: 5,
              top: 0,
              bottom: 0,
              left: 0,
            }}
          />
        )}
        <div className="d-flex">
          <CheckBoxInput
            type="checkbox"
            color="#f7951e"
            checked={checked}
            onChange={checkedChange}
          />
        </div>
      </TableUi.td>
      <TableUi.td>
        <ShipmentTypeRender value={item.carrier} />
        {/* {removeDuplicates(
          item.shipments.map(({ shipment_type }) => shipment_type)
        ).map((value) => (
          <ShipmentTypeRender key={value} value={value} />
        ))} */}
      </TableUi.td>
      <TableUi.td>
        {removeDuplicates(
          props.item.shipments.map((e) => e.order?.order_shop?.identifier)
        )
          .sort((a, b) => (a.id > b.id ? 1 : -1))
          .map((identifier) => (
            <div
              key={identifier}
              className="flex align-items-center"
              style={{
                whiteSpace: "nowrap",
              }}
            >
              <GoPrimitiveDot className={"text-success"} />
              <span>{identifier}</span>
            </div>
          ))}
      </TableUi.td>
      <TableUi.td>
        <div className="d-flex">
          <Tooltip placement="top" title={"Call courier"}>
            <div
              className="d-flex justify-content-center align-items-center bg-orange rounded cursor-pointer mr-1"
              style={{ width: 22, height: 22 }}
              onClick={() => {
                onModalAction("call_courrier", { id: item.id });
              }}
            >
              <img src={DeliverySvg} />
            </div>
          </Tooltip>
          {!props.item.closed_at && (
            <Tooltip placement="top" title={"Close manifest"}>
              <div
                className="d-flex justify-content-center align-items-center bg-danger rounded cursor-pointer"
                style={{ width: 22, height: 22 }}
                onClick={() => {
                  AntdConfirm({
                    title: "Are you sure want to close the manifest?",
                    onOk: async () => await dispatch(close_manifest(item.id)),
                  });
                }}
              >
                <AiOutlineCloseCircle color={"#fff"} size={12} />
              </div>
            </Tooltip>
          )}
        </div>
        {combined_shipment && (
          <LongButton
            className="text-xss text-white mt-2"
            style={{
              width: 100,
              backgroundColor: colors["purple"],
              fontSize: 9,
              height: "auto",
            }}
            text={"Combined shipment"}
          />
        )}
      </TableUi.td>
      <TableUi.td>
        {props.item.api_errors && (
          <Tooltip placement="top" title={props.item.api_errors}>
            <MdErrorOutline className="text-danger" size={20} />
          </Tooltip>
        )}
      </TableUi.td>
      <TableUi.td>
        <GoPrimitiveDot
          style={
            props.item.closed_at !== null
              ? { color: "green" }
              : { color: "red" }
          }
        />
      </TableUi.td>
      <TableUi.td>
        <GoPrimitiveDot
          style={
            props.item.called_at !== null
              ? { color: "green" }
              : { color: "red" }
          }
        />
      </TableUi.td>
      <TableUi.td>
        {props.item.pickup_address_id == 1 && (
          <Tooltip
            placement="top"
            title={
              props.item.also_email_sent_at
                ? prettyDateFormat(props.item.also_email_sent_at)
                : "Unsent email"
            }
          >
            <GoPrimitiveDot
              color={props.item.also_email_sent_at ? "green" : "red"}
            />
          </Tooltip>
        )}
      </TableUi.td>
      <TableUi.td>
        <Tooltip
          placement="top"
          title={
            props.item.labels_sent_at
              ? prettyDateFormat(props.item.labels_sent_at)
              : "Unsent labels"
          }
        >
          <GoPrimitiveDot color={props.item.labels_sent_at ? "green" : "red"} />
        </Tooltip>
      </TableUi.td>
      <TableUi.td>
        {moment(props.item.created_at).format("YYYY-MM-DD HH:mm")}
      </TableUi.td>
      <TableUi.td>{props.item.pickup_address.code}</TableUi.td>
      <TableUi.td>{ordersId(props.item.shipments)}</TableUi.td>
      <TableUi.td>
        <div
          style={{
            minWidth: 250,
          }}
        >
          {props.item.shipments.map((ship) => (
            <div key={`ship_key-${ship.id}`}>
              <div className="font-weight-bold">
                {ship.order.id_order} - {ship.shipment_address?.name || ""}
              </div>
              {ship.shipment_order_rows.map((or, idx) => {
                if (or.deleted_at ? true : or.canceled_at) {
                  return (
                    <div key={`sub_${or.id}_${idx}`}>
                      <del>
                        <p className="mb-0 font-weight-bold px-2">
                          {or.quantity || Math.floor(or.order_row?.quantity)}*
                          {or.order_row?.product_name || or.order_row_id}
                        </p>
                      </del>
                    </div>
                  );
                }
                return (
                  <div key={`sub_${or.id}_${idx}`}>
                    <p className="mb-0 font-weight-bold px-2">
                      {or.quantity || Math.floor(or.order_row?.quantity)}*
                      {or.order_row?.product_name || or.order_row_id}
                    </p>
                  </div>
                );
              })}
              <hr />
            </div>
          ))}
        </div>
      </TableUi.td>
      <TableUi.td>{props.item.shipments.length}</TableUi.td>
      <TableUi.td>{countPackets(props.item.shipments)}</TableUi.td>
      <TableUi.td>{countWeight(props.item.shipments)}</TableUi.td>
      <TableUi.td className={"text-nowrap"}>
        {props.item.shipments.length > 0 && (
          <SimpleDownloadButton
            onClick={() => manifestDownload(props.item.id)}
          />
        )}
      </TableUi.td>
      <TableUi.td className={"text-nowrap"}>
        {props.item.shipments.length > 0 && (
          <SimpleDownloadButton
            extra_text={props.item.pickup_address?.label_sizes?.includes("A4")}
            onClick={() =>
              manifestDownloadStackedLabels(props.item.id, props.item.carrier)
            }
          />
        )}
      </TableUi.td>
      <TableUi.td className={"text-nowrap"}>
        {props.item.shipments.length > 0 && (
          <SimpleDownloadButton
            extra_text={props.item.pickup_address?.label_sizes?.includes("A5")}
            onClick={() =>
              manifestDownloadStackedLabelsA5(props.item.id, props.item.carrier)
            }
          />
        )}
      </TableUi.td>
      <TableUi.td className={"text-nowrap"}>
        <SimpleDownloadButton
          extra_text={props.item.pickup_address?.label_sizes?.includes("A6")}
          onClick={() => manifestLabelsDownload(props.item.id)}
        />
      </TableUi.td>
    </TableUi.tr>
  );
}
